export default "__VITE_ASSET__39105ee8__"